import BucketApiRequest from "./BucketApiRequest";
import { GET_BENEFICIARY_TYPE_URL } from "../ApiUrls";

export default class GetBeneficiaryTypeApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_BENEFICIARY_TYPE_URL;
  };
}
